import {AppRoutingModule} from './app-routing.module';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {SubmitComponent} from '../submit/submit.component';
import {DataService} from '../Services/data.service';
import {StandardDaysComponent} from '../standardDays/standardDays.component';

import {LoginComponent} from '../login/login.component';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {LogoutComponent} from '../logout/logout.component';
import {CalendarModule} from 'angular-calendar';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MatButtonModule, MatCheckboxModule} from '@angular/material';
import {KantineComponent} from '../Canteen/canteen.component';
import {WebSocketService} from 'app/Services/webSocket.service';
import {StatisticsCanteenComponent} from '../StatisticsCanteen/statisticsCanteen.component';
import {SecretaryComponent} from '../Secretary/secretary.component';
import {HRAndFinanceComponent} from '../HRAndFinance/HRAndFinance.component';
import {LiveComponent} from '../Live/live.component';
import {TelfortComponent} from '../Telfort/telfort.component';


@NgModule({
  declarations: [
    AppComponent,
    SubmitComponent,
    LoginComponent,
    LogoutComponent,
    LiveComponent,
    KantineComponent,
    StandardDaysComponent,
    StatisticsCanteenComponent,
    TelfortComponent,
    SecretaryComponent,
    HRAndFinanceComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    MatButtonModule,
    MatCheckboxModule,
    CalendarModule.forRoot(),
    NgbModule.forRoot(),
  ],
  providers: [DataService, WebSocketService, {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/App/app.module.ts